<template>
	<td>
		<a class="button is-small is-white" @click="levelDown">
			<span class="icon is-small">
				<i class="fas fa-minus-circle"></i>
			</span>
		</a>
			{{ level }}
		<a class="button is-small is-white" @click="levelUp">
			<span class="icon is-small">
				<i class="fas fa-plus-circle"></i>
			</span>
		</a>
	</td>
</template>

<script>

export default {
	name: 'table-level-cell',

	props: {
		level: Number
	},

	methods: {
		levelDown() {
			if(this.level != 1) this.$emit('update:level', this.level - 1)
		},

		levelUp() {
			if(this.level != 5) this.$emit('update:level', this.level + 1)
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/TableLevelCell.vue